import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http'
import { Meta } from '@angular/platform-browser';
import {Title} from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
//import { ConfigurationService } from './../configuration.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css'],
  providers: []
})
export class ResetComponent implements OnInit {

  constructor(private httpService: HttpClient, private route: ActivatedRoute, public meta: Meta, public titleService: Title,  @Inject(DOCUMENT) private _document: HTMLDocument) {
    //this.getApiUrl = config.getApiUrl();
    //this.getApiRedirect = config.getApiRedirect();
   }

  content;
  subdomain;
  meta_title;
  meta_description;
  meta_keywords;
  title;
  name;
  description;
  name2;
  description2;
  android_link;
  ios_link;
  footer_description;
  privacy_policy_title;
  privacy_policy_description;
  color_1;
  color_2;
  logo;
  background_img;
  background_color;
  favicon;
  font;
  google_analytics;


  terms_of_service_title;
  terms_of_service_desctiption;

  footer_desc;
  google_play_desc;
  huawei_desc;
  app_store_desc;
  lang;
  huawei_link;
  status;
  status2;


  ngOnInit () {

    // const token: string = this.route.snapshot.queryParamMap.get('id');
    // const app_id: string = this.route.snapshot.queryParamMap.get('app');
    // var status;
    // var host = window.location.host;
    // var subdomain = host.split('.')[0];
    //
    // //check is not null and redirect

    var host = window.location.host;
    var page = window.location.pathname;
    var subdomain = host.split('.')[0];
    const subdomain_lang: string = this.route.snapshot.queryParamMap.get('lang');
    const token: string = this.route.snapshot.queryParamMap.get('id');
    const app_id: string = this.route.snapshot.queryParamMap.get('app');
    var api_url = '';


    if(subdomain_lang === '' || subdomain_lang == null){

      api_url = 'https://dev-api-v2.loyaltyclub.pl/landingpage/' + subdomain;
    }else{
      api_url = 'https://dev-api-v2.loyaltyclub.pl/landingpage/' + subdomain + '/' + subdomain_lang;
    }

    if(token === '' || token == null){
      window.location.href = 'http://loyaltyclub.pl';
    }

    if(app_id === '' || app_id == null){
      window.location.href = 'http://loyaltyclub.pl';
    }

     // 0 - bledne dane, 1 - brak app_id, 2 - brak usera, 3 - email zostal juz potwierdzony, 4 - adres zostal potwierdzony poprawnie



    this.httpService.get('https://dev-api-v2.loyaltyclub.pl/api/auth/reset/password/app_id/'+app_id+ '/token/'+token).subscribe(
    //this.httpService.get('https://dev-api-v2.loyaltyclub.pl'+'/token/'+token+'/app/'+app_id+'/reset/password').subscribe(
       data => {
              if(data === 'error'){
                window.location.href = 'http://loyaltyclub.pl';
              }

        this._document.getElementById('content2').style.display = "block";
        this.content = data;
        status = this.content.status;
        this.httpService.get(api_url).subscribe(
        //this.httpService.get('https://dev-api-v2.loyaltyclub.pl/'+subdomain+'/landingpage').subscribe(
          data => {


            if(data === 'error'){
              window.location.href = 'http://loyaltyclub.pl';
            }

            (err: HttpErrorResponse) => {
              //console.log (err.message);
              window.location.href = 'http://loyaltyclub.pl';
            }

            // this.content = data;
            // this.subdomain = this.content.subdomain;
            // this.meta_title = this.content.meta_title;
            // this.meta_description = this.content.meta_description;
            // this.meta_keywords = this.content.meta_keywords;
            // this.title = this.content.title;
            //
            // this.terms_of_service_title = this.content.terms_of_service_title;
            // this.terms_of_service_desctiption = this.content.terms_of_service_desctiption;
            this.content = data;
            console.log(this.content);
            console.log(this.content.translations.meta_title);
            this.subdomain = this.content.subdomain;


            this.footer_desc = this.content.translations.footer_desc;
            this.google_play_desc = this.content.translations.google_play_desc;
            this.app_store_desc = this.content.translations.app_store_desc;
            this.huawei_desc = this.content.translations.huawei_desc;


            this.lang = subdomain_lang;

            this.meta_title = this.content.translations.meta_title;
            this.meta_description = this.content.translations.meta_description;
            this.meta_keywords = this.content.translations.meta_keywords;
            this.title = this.content.translations.title;
            this.name = this.content.translations.name;
            this.description = this.content.translations.description;
            this.android_link = this.content.android_link;
            this.ios_link = this.content.ios_link;
            this.huawei_link = this.content.huawei_link;
            this.footer_description = this.content.translations.footer_desctiption;
            this.privacy_policy_title = this.content.translations.privacy_policy_title;
            this.privacy_policy_description = this.content.translations.privacy_policy_description;
            this.color_1 = this.content.color_1;
            this.color_2 = this.content.color_2;
            this.logo = this.content.logo;
            this.background_img = this.content.background_img;
            this.background_color = this.content.background_color;
            this.favicon = this.content.favicon;
            this.font = this.content.font;
            this.google_analytics = this.content.google_analytics;


            if(status == '0'){
              this.status2 = '0';
              this.name2 = this.content.translations.reset_0_name;
              this.description2 = this.content.translations.reset_0_desc;
            }else if(status == '4'){
              this.status2 = '4';
              this.name2 = this.content.translations.reset_4_name;
              this.description2 = this.content.translations.reset_4_desc;
            }

            this.terms_of_service_title = this.content.translations.terms_of_service_title;
            this.terms_of_service_desctiption = this.content.translations.terms_of_service_desctiption;
            this.meta.addTag({ name: 'description', content: this.meta_description });
            this.meta.addTag({ name: 'keywords', content: this.meta_keywords });
            this.meta.addTag({ name: 'description', property:'og:url', content: this.meta_description });
            this.meta.addTag({ property:'og:url', content: this.subdomain });
            this.meta.addTag({ property:'og:title', content: this.meta_title });
            this.meta.addTag({ property:'og:image', content: this.background_img });
            this.meta.addTag({ property:'og:image:type', content: 'image/jpeg' });
            this.meta.addTag({ property:'og:image:width', content: '1200' });
            this.meta.addTag({ property:'og:height', content: '630' });
            this.titleService.setTitle(this.meta_title);
            this._document.getElementById('appFavicon').setAttribute('href', this.favicon);
            var injectScript = "https://www.googletagmanager.com/gtag/js?id=" + this.google_analytics;
            this._document.getElementById('appGoogle').setAttribute('src', injectScript);
            var googleScript = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '"+this.google_analytics+"');"
            const script = document.createElement('script');
            script.innerHTML = googleScript;
            this._document.head.appendChild(script);
            // this.android_link = this.content.android_link;
            // this.ios_link = this.content.ios_link;
            // this.footer_description = this.content.footer_description;
            // this.privacy_policy_title = this.content.privacy_policy_title;
            // this.privacy_policy_description = this.content.privacy_policy_description;
            // this.color_1 = this.content.color_1;
            // this.color_2 = this.content.color_2;
            // this.logo = this.content.logo;
            // this.background_img = this.content.background_img;
            // this.background_color = this.content.background_color;
            // this.favicon = this.content.favicon;
            // this.font = this.content.font;
            // this.google_analytics = this.content.google_analytics;
            //
            // this.meta.addTag({ name: 'description', content: this.meta_description });
            // this.meta.addTag({ name: 'keywords', content: this.meta_keywords });
            // this.meta.addTag({ name: 'description', property:'og:url', content: this.meta_description });
            // this.meta.addTag({ property:'og:url', content: this.subdomain });
            // this.meta.addTag({ property:'og:title', content: this.meta_title });
            // this.meta.addTag({ property:'og:image', content: this.background_img });
            // this.meta.addTag({ property:'og:image:type', content: 'image/jpeg' });
            // this.meta.addTag({ property:'og:image:width', content: '1200' });
            // this.meta.addTag({ property:'og:height', content: '630' });
            // this.titleService.setTitle(this.meta_title);
            //
            // this._document.getElementById('appFavicon').setAttribute('href', this.favicon);
            // var injectScript = "https://www.googletagmanager.com/gtag/js?id=" + this.google_analytics;
            // this._document.getElementById('appGoogle').setAttribute('src', injectScript);
            // var googleScript = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '"+this.google_analytics+"');"
            // const script = document.createElement('script');
            // script.innerHTML = googleScript;
            // this._document.head.appendChild(script);




            const css = "html,body {width: 100%;height: 100%;}body{font-family: '"+this.font+"', sans-serif;color:"+this.color_1+"  !important;background-color:"+this.background_color+"  !important;}"+

            "::-webkit-scrollbar {width: 5px;}::-webkit-scrollbar-track {background: "+this.color_2+";}::-webkit-scrollbar-thumb {background: "+this.color_1+";}::-webkit-scrollbar-thumb:hover {background: #555;}"+

            ".alertbody{position:fixed;left:30px;right:30px;top:30px;z-index:1000;} @media (max-width: 767px) {.alertbody{top:40%;}}"+

            ".alert{-webkit-box-shadow: 3px 4px 22px -10px rgba(0,0,0,0.75);-moz-box-shadow: 3px 4px 22px -10px rgba(0,0,0,0.75);box-shadow: 3px 4px 22px -10px rgba(0,0,0,0.75);border:none;-webkit-border-radius: 15px !important;-moz-border-radius: 15px !important;border-radius:15px;}"+

            ".alert-success{background-color: #5da350;color:#ffffff;}.alert-danger{background-color: #be2626;color:#ffffff;}.alert-info{background-color: #5782f3;color:#ffffff;}.alert i{font-size:48px;margin-bottom:30px;margin-top:30px;}"+

             "hr {color:"+this.color_2+" !important; background-color:"+this.color_2+" !important;width: 50%;max-width: 50px;height:2px;border:0px; margin: 0 auto;opacity: 1;}#nav_bar{background-color:"+this.color_1+"  !important;color:"+this.color_2+"  !important;}"+

            ".navbar-brand img{margin-right:15px;} .navbar-brand, .nav-link{color:"+this.color_2+"  !important;} .navbar-brand:hover, .nav-link:hover{text-decoration:none;} .navbar-toggler-icon{ color:"+this.color_2+"  !important;}"+

            ".carousel-caption{position: absolute;width: 100%;min-height: auto;text-align: center;padding:0px;top:30%;left:0px;right:0px;display:none;} @media (min-width: 767px) and (max-width: 1024px) {.carousel-caption{top:0% !important;}}"+

            "@media (min-width: 1025px) and (max-width: 1200px) {.carousel-caption{top:10% !important;}} @media (min-width: 1201px) and (max-width: 1440px) {.carousel-caption{top:20% !important;}}"+

            ".carousel-caption p{font-weight:300;color:"+this.color_1+"  !important;}h5,.carousel-caption h5{font-weight:700;color:"+this.color_1+"  !important;}.logotype {width:150px;height:150px;margin-bottom:30px;}"+

            ".btn {-webkit-border-radius: 25px !important;-moz-border-radius: 25px !important;border-radius: 25px !important;color:"+this.color_2+"; background-color:"+this.color_1+"; border: none !important; margin-bottom:15px;}"+

            ".btn:hover{background-color:"+this.color_2+" !important; color:"+this.color_1+"  !important; border: none !important;} @media (min-width: 767px){#mobile_links{}}"+

            "#mobile_links {padding:50px;color:#000000;background-color:"+this.background_color+"  !important;}#mobile_links *, #mobile_links p, #mobile_links h5 {color:#000000;}"+

            "#mobile_links .btn {-webkit-border-radius: 25px !important;-moz-border-radius: 25px !important;border-radius: 25px !important;color:"+this.color_2+"; background-color:"+this.color_1+"; border: none !important; margin-bottom:15px;}"+

            "#mobile_links .btn:hover{background-color:"+this.color_2+"  !important; color:"+this.color_1+"  !important;border: none !important;}#mobile_links .fa-regular,#mobile_links .fa-brands{color:"+this.color_2+";}"+

            "#content *,#content p,#content h1 {color:#000000 !important;}#content hr{ color:#000000 !important;background-color:#000000 !important;margin-bottom:30px;}#footer{background-color:"+this.color_1+"  !important;color:"+this.color_2+"; padding:50px;}"+

            "#footer h3,#footer h5 {color:"+this.color_2+"  !important;}"+

            ".cp {position: fixed;text-align:center;color: #ffffff;background-color: #ffffff;right:20px;bottom:20px;width: 66px;height: 66px;z-index: 1000;border: none;text-align:center;"+
            "padding:13px 10px 8px 10px;font-weight:bold;-webkit-border-radius: 33px !important;-moz-border-radius: 33px !important;border-radius:33px;-webkit-box-shadow: 3px 4px 22px -10px rgba(0,0,0,0.75);-moz-box-shadow: 3px 4px 22px -10px rgba(0,0,0,0.75);box-shadow: 3px 4px 22px -10px rgba(0,0,0,0.75);}"+
            "#mobile_links .btn:hover .fa-regular, #mobile_links .btn:hover .fa-brands {color:"+this.color_1+" !important; border: none !important;}";

            const head = document.getElementsByTagName('head')[0];
            const style = document.createElement('style');
            style.type = 'text/css';
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);





            //console.log(this.content);
          },
          (err: HttpErrorResponse) => {
            //console.log (err.message);
              window.location.href = 'http://loyaltyclub.pl';
          }
        );
      },
        (err: HttpErrorResponse) => {
          window.location.href = 'http://loyaltyclub.pl';
        }
      );




    // var host = window.location.host;
    // var subdomain = host.split('.')[0];






  //   data => {
  //
  //
  //     if(data === 'error'){
  //       window.location.href = 'http://loyaltyclub.pl';
  //     }
  //
  //     (err: HttpErrorResponse) => {
  //       //console.log (err.message);
  //       window.location.href = 'http://qrtag.pl';
  //     }
  //
  //     this.content = data;
  //     this.subdomain = this.content.subdomain;
  //     this.meta_title = this.content.meta_title;
  //     this.meta_description = this.content.meta_description;
  //     this.meta_keywords = this.content.meta_keywords;
  //     this.title = this.content.title;
  //     if(status === '0'){
  //       this.name = 'BŁĘDNE DANE!';
  //       this.description = 'Link aktywacyjny jest nieprawidłowy.';
  //     }else if(status == '1'){
  //       this.name = 'BŁĘDNE DANE!';
  //       this.description = 'Link aktywacyjny jest nieprawidłowy.';
  //     }else if(status == '2'){
  //       this.name = 'BŁĘDNE DANE!';
  //       this.description = 'Link aktywacyjny jest nieprawidłowy.';
  //     }else if(status == '3'){
  //       this.name = 'BŁĄD!';
  //       this.description = 'Twoje konto zostało już aktywowane.';
  //     }else if(status == '4'){
  //       this.name = 'DZIĘKUJEMY ZA REJESTRACJĘ!';
  //       this.description = 'Twoje konto w aplikacji jest już aktywne możesz się zalogować';
  //     }
  //     this.android_link = this.content.android_link;
  //     this.ios_link = this.content.ios_link;
  //     this.footer_description = this.content.footer_description;
  //     this.privacy_policy_title = this.content.privacy_policy_title;
  //     this.privacy_policy_description = this.content.privacy_policy_description;
  //     this.color_1 = this.content.color_1;
  //     this.color_2 = this.content.color_2;
  //     this.logo = this.content.logo;
  //     this.background_img = this.content.background_img;
  //     this.background_color = this.content.background_color;
  //     this.favicon = this.content.favicon;
  //     this.font = this.content.font;
  //     this.google_analytics = this.content.google_analytics;
  //
  //     this.meta.addTag({ name: 'description', content: this.meta_description });
  //     this.meta.addTag({ name: 'keywords', content: this.meta_keywords });
  //     this.meta.addTag({ name: 'description', property:'og:url', content: this.meta_description });
  //     this.meta.addTag({ property:'og:url', content: this.subdomain });
  //     this.meta.addTag({ property:'og:title', content: this.meta_title });
  //     this.meta.addTag({ property:'og:image', content: this.background_img });
  //     this.meta.addTag({ property:'og:image:type', content: 'image/jpeg' });
  //     this.meta.addTag({ property:'og:image:width', content: '1200' });
  //     this.meta.addTag({ property:'og:height', content: '630' });
  //     this.titleService.setTitle(this.meta_title);
  //
  //     this._document.getElementById('appFavicon').setAttribute('href', this.favicon);
  //     var injectScript = "https://www.googletagmanager.com/gtag/js?id=" + this.google_analytics;
  //     this._document.getElementById('appGoogle').setAttribute('src', injectScript);
  //     var googleScript = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '"+this.google_analytics+"');"
  //     const script = document.createElement('script');
  //     script.innerHTML = googleScript;
  //     this._document.head.appendChild(script);
  //
  //
  //
  //
  //     const css = "body{font-family: '"+this.font+"', sans-serif;color:"+this.color_1+";background-color:"+this.background_color+";}"+
  //
  //   	".navbar-default .navbar-header .navbar-brand,.navbar-default,.navbar-brand:hover{font-family: '"+this.font+"', sans-serif;background-color:"+this.color_2+";border:none;}"+
  //
  //   	".navbar-default .navbar-header .navbar-brand:hover,.navbar-default .navbar-header .navbar-brand:focus {color: "+this.color_1+";}"+
  //
  //     ".btn {font-family: '"+this.font+"', sans-serif;}"+
  //
  //   	"h1,h2,h3,h4,h5,h6 {font-family: '"+this.font+"', sans-serif;color: "+this.color_1+";}"+
  //
  //   	"a{color:"+this.color_1+";}"+
  //
  //   	"a:hover, a:focus {color: "+this.color_2+";}"+
  //
  //   	".header{ background: url('"+this.background_img+"') center bottom; color: "+this.color_1+"; background-color:"+this.background_color+"; }"+
  //
  //     "#contact{color:"+this.color_1+";background-color:"+this.color_2+";}"+
  //
  //   	".navbar-default .navbar-header .navbar-brand {color: "+this.color_1+";}"+
  //
  //     ".navbar-default .nav > li>a, .navbar-default .nav>li>a:focus {color: "+this.color_1+";}"+
  //
  //     ".btn-primary {color: "+this.color_1+";background: none !important;border: solid 2px "+this.color_1+";}"+
  //
  //     ".btn-primary:hover,.btn-primary:focus,.btn-primary.focus,.btn-primary:active,.btn-primary.active,.open > .dropdown-toggle.btn-primary {border: solid 2px "+this.color_1+";color:"+ this.color_1 +" ;background-color: "+this.color_2+" !important;}" +
  //
  //
  //   ".btn-primary.disabled,.btn-primary[disabled],fieldset[disabled] .btn-primary,.btn-primary.disabled:hover,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary:hover,.btn-primary.disabled:focus,.btn-primary[disabled]:focus,fieldset[disabled] .btn-primary:focus,.btn-primary.disabled.focus,.btn-primary[disabled].focus,fieldset[disabled] .btn-primary.focus,.btn-primary.disabled:active,.btn-primary[disabled]:active,fieldset[disabled] .btn-primary:active,.btn-primary.disabled.active,.btn-primary[disabled].active,fieldset[disabled] .btn-primary.active {border-color: "+this.color_1+";background-color: "+this.color_1+";}"+
  //
  //   "hr {border-color: "+this.color_1+";}" +
  //   ".header .header-content .header-content-inner p, .header .header-content .header-content-inner h1, .header .header-content .header-content-inner h2, .header .header-content .header-content-inner h3, .header " +
  //   ".header-content .header-content-inner h4, .header .header-content .header-content-inner h5 {color: "+ this.color_1 +";margin:10px;}";
  //
  //     const head = document.getElementsByTagName('head')[0];
  //     const style = document.createElement('style');
  //     style.type = 'text/css';
  //     style.appendChild(document.createTextNode(css));
  //     head.appendChild(style);
  //
  //
  //
  //
  //
  //     //console.log(this.content);
  //   },
  //   (err: HttpErrorResponse) => {
  //     //console.log (err.message);
  //     window.location.href = 'http://loyaltyclub.pl';
  //   }
  // );
}

}
